import { Component, inject } from '@angular/core';
import { StateService } from '../../services/state.service';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Button } from 'primeng/button';
import { TauresMessageModule } from '@taures/taures-components/taures-message';

@Component({
  templateUrl: './anmeldeschluss-abgelaufen.component.html',
  styleUrls: ['./anmeldeschluss-abgelaufen.component.scss'],
  imports: [DatePipe, RouterLink, Button, TauresMessageModule],
  standalone: true
})
export class AnmeldeschlussAbgelaufenComponent {
  protected readonly stateService: StateService = inject(StateService);
}
